module.exports = __webpack_public_path__ + "img/ione1.088686ba.png";